import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const ContextMenu = ({ position, items, onClose }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };
        document.addEventListener('click', handleClickOutside);
        document.addEventListener('contextmenu', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('contextmenu', handleClickOutside);
        };
    }, [onClose]);

    return (
        <ul
            ref={menuRef}
            style={{
                position: 'fixed',
                top: position.y,
                left: position.x,
                backgroundColor: '#043e5c',
                color: 'white',
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '8px 0',
                zIndex: 1000,
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
                listStyle: 'none',
                cursor: 'pointer',
                minWidth: '200px',
                maxWidth: '260px',
                wordWrap: 'break-word',
                animation: 'fadeIn 0.15s ease-out'
            }}
        >
            {items.map(({ key, label, icon, onClick, isDivider }) => {
                if (isDivider) {
                    return <hr key={key} style={{ border: 'none', borderTop: '1px solid #666', margin: '4px 0' }} />;
                }
                return (
                    <li
                        key={key}
                        onClick={onClick}
                        style={{
                            padding: '8px 16px',
                            transition: 'background-color 0.2s ease, transform 0.15s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#05507a';
                            e.currentTarget.style.transform = 'scale(1.01)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'white' }}>
                            {icon && <img src={icon} alt={key} width={16} height={16} />}
                            {label}
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

ContextMenu.propTypes = {
    position: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
    }).isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.node,
            icon: PropTypes.string,
            onClick: PropTypes.func,
            isDivider: PropTypes.bool
        })
    ).isRequired,
    onClose: PropTypes.func.isRequired
};

export default ContextMenu;



// WEBPACK FOOTER //
// ./src/components-new/ContextMenu.jsx